
import { defineComponent } from 'vue';
import TheHeader from '@/components/organisms/TheHeader.vue';
import TheFooter from '@/components/organisms/TheFooter.vue';

export default defineComponent({
  name: 'General',
  components: { TheHeader, TheFooter },
});
